module.exports = __webpack_public_path__ + "img/loginLogo.e16faee0.png";